<template>

    <div id="dashboard">
    <my-tour :steps="steps" name="steps1" v-if="showTutorial"></my-tour>
        <!-- <my-tour></my-tour> -->
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina class="ml-2" titulo="Dashboard" />
                <!--card stats start-->
                <div id="card-stats">
                    <div class="container">
                        <div class="row">
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Prospecção"
                                    :numero="this.prospeccao"
                                    icone="input"
                                    cor-fundo="blue-aqua-light"
                                    cor-texto="blue-aqua-light-text"
                                    estagioId="1"
                                />
                            </div>
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Chamada Telefônica"
                                    :numero="this.chamadaTelefonica"
                                    icone="phone"
                                    cor-fundo="pink-light"
                                    gradiente="darken-4"
                                    cor-texto="pink-light-text"
                                    estagioId="2"
                                />
                            </div>
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Primeira Visita"
                                    :numero="this.primeiraVisita"
                                    icone="place"
                                    cor-fundo="yellow-light"
                                    gradiente="accent-4"
                                    cor-texto="yellow-light-text"
                                    estagioId="3"
                                />
                            </div>
                            <div class="col s12 m6 l3" v-if="checaCargoUsuario([cargoDono, cargoParceiro, cargoGerente, cargoEspecialista])">
                                <card-info
                                    titulo="Segunda Visita"
                                    :numero="this.segundaVisita"
                                    icone="play_circle_filled"
                                    cor-fundo="orange-light"
                                    gradiente="accent-2"
                                    cor-texto="orange-light-text"
                                    estagioId="6"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Em Negociação"
                                    :numero="this.negociacao"
                                    icone="business_center"
                                    cor-fundo="blue-light"
                                    gradiente=""
                                    cor-texto="blue-light-text"
                                    estagioId="9"
                                />
                            </div>
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Em Processo de Análise Seguradora"
                                    :numero="this.negativado"
                                    icone="settings"
                                    cor-fundo="red-light"
                                    gradiente="darken-2"
                                    cor-texto="red-light-text"
                                    estagioId="5"
                                />
                            </div>
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Efetivado"
                                    :numero="this.efetivado"
                                    icone="check"
                                    cor-fundo="green-light"
                                    gradiente="darken-4"
                                    cor-texto="green-light-text"
                                    estagioId="4"
                                />
                            </div>
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Análise de Necessidades"
                                    :numero="this.emEspera"
                                    cor="#9c27b0"
                                    icone="pause"
                                    cor-fundo="blue"
                                    gradiente="darken-4"
                                    cor-texto="blue-text"
                                    estagioId="7"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Não Efetivado"
                                    :numero="this.perdido"
                                    icone="close"
                                    cor-fundo="reddark"
                                    cor-texto="reddark-text"
                                    estagioId="8"
                                />
                            </div>
                            <div class="col s12 m6 l3">
                                <card-info
                                    titulo="Total de Leads"
                                    :numero="this.totalLeads"
                                    cor="#9c27b0"
                                    icone="insert_chart"
                                    cor-fundo="purple-light"
                                    gradiente="darken-2"
                                    cor-texto="purple-light-text"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="container" v-if="showGrafico">
                        <div class="row">
                            <div class="col m12 s12 l12">
                                <div class="card">
                                    <div class="card-content">
                                        <span class="card-title left-align">Gráfico</span>
                                        <p class="left-align">Clique no items da legenda para filtrar</p>
                                        <grafico-linha v-if="showGrafico" :dadosGrafico="dadosGrafico"></grafico-linha>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <!--kanban -->
                <div id="kanban" class="container" v-if="checaCargoUsuario([cargoCorretor, cargoLider])">
                    <div class="row">
                        <kanban />
                    </div>
                </div>
                 <!--kanban end-->
                <!--card stats end-->
                <div id="full-calendar" class="container">
                    <div class="row">
                        <calendar></calendar>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
        <!-- <div class="fixed-action-btn active" style="top: 70px; right: 19px; z-index: 90 !important;">
            <button
                class="btn-floating btn-large btn-default waves-effect waves-light gradient-45deg-blue-indigo"
                v-tooltip.left="'Clique para exibir/esconder o gráfico'"
                @click="abrirGrafico()"
            >
                <i v-if="! showGrafico" class="material-icons">insert_chart</i>
                <i v-if="showGrafico" class="material-icons">close</i>
            </button>
        </div> -->
  </div>
</template>
<script>
    import Auth from '@/store/auth';
    import CardInfo from '@/components/dashboard/CardInfo';
    import Kanban from '@/components/kanban/Kanban';
    import Calendar from '@/components/common/Calendar';
    import TituloPagina from '@/components/common/TituloPagina';
    import GraficoLinha from '@/components/common/GraficoLinha';
    import { api } from '@/helpers/api';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, PARCEIRO, MASTER } from '@/constants/funcionarioCargo.js';
    import MyTour from '@/components/common/MyTour.vue'
    import swal, { mixin } from 'sweetalert2';
    import TourStore from '@/store/tour';
    import TourHelper from '@/helpers/tour';
    import { isMultiEmpresa } from '@/environment';

    export default {
        components: {
            CardInfo,
            Kanban,
            Calendar,
            TituloPagina,
            GraficoLinha,
            MyTour
        },

        data: () => ({
            prospeccao: 0,
            chamadaTelefonica: 0,
            primeiraVisita: 0,
            efetivado: 0,
            negativado: 0,
            segundaVisita: 0,
            emEspera: 0,
            perdido: 0,
            negociacao: 0,
            totalLeads: 0,
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoLider: null,
            cargoParceiro: null,
            dadosGrafico: [],
            showGrafico: false,
            showTutorial: false,
            showMessage: false,
            steps: [
                {
                    parent: '#card-stats',
                    target: '#card-stats',
                    content: 'Na <b>Dashboard</b>, podemos ver a esteira completa, ou seja, todos os caminhos que o Lead passa para se tornar efetivamente um cliente! Clicando em cada um dos passos, é mostrado os Leads de cada etapa!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        // placement: 'left',
                        menu: false
                    }
                },
                {
                    parent: '#kanban',
                    target: '#kanban',
                    content: 'Podemos acompanhar os leads que ainda não foram efetivados, bem como a data de indicação e espera!',
                    params: { cargos: [CORRETOR, LIDER],
                        placement: 'top',
                        toTop: true,
                        menu: false
                    }

                },
                {
                    parent: '#calendar',
                    target: '#calendar',
                    content: 'Podemos ver a agenda de todos os funcionários juntos e organizados em um único lugar!',
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'top',
                        toTop: true,
                        menu: false

                    }

                },
                {
                    parent: '#calendar',
                    target: '#calendar',
                    content: 'Podemos ver a agenda com todos os eventos criados, visitas e contatos agendados!',
                    params: { cargos: [PARCEIRO, CORRETOR, LIDER],
                        placement: 'top',
                        toTop: true,
                        menu: false

                    }

                },
                {
                    parent: '#subtitle',
                    target: '#subtitle',
                    content: 'Cada funcionário é identificado por uma cor específica, para que facilite a identificação na agenda!',
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'right',
                        menu: false

                    }

                },
                {
                    parent: '#filter-calendar1',
                    target: '#filter-calendar1',
                    content: 'Se quiser encontrar um funcionário especifico para ver separado, basta digitar o nome aqui e selecioná-lo!',
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'left',
                        menu: false

                    }

                },
                {
                    parent: '#filter-calendar2',
                    target: '#filter-calendar2',
                    content: 'Se quiser filtrar a agenda por estados, também é possivel marcando o campo correspondente ao que deseja!',
                    params: { cargos: [DONO, GERENTE, ESPECIALISTA],
                        placement: 'left',
                        menu: false

                    }

                },
                {
                    parent: '#left-sidebar-nav',
                    target: '#gerenciamento',
                    content: 'Para vermos os Leads já cadastrados, basta no menu clicar em <b>Gerenciamento de Leads</b>!',
                    params: { cargos: isMultiEmpresa ? [PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER] : [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: true,
                        route: '/gerenciamento-leads'
                    }
                },
                 {
                    multiempresa: true,
                    parent: '#left-sidebar-nav',
                    target: '#importacao-cliente',
                    content: 'Para importar Leads, basta no menu Cliente clicar em <b>Importação</b>!',
                     params: { cargos: [DONO],
                        placement: 'left',
                        menu: true,
                        route: '/clientes/importacao',
                        subMenu: true,
                        subMenuTarget:"#group-cliente"
                    }
                },
                // {
                //     parent: '#left-sidebar-nav',
                //     target: '#importacao-cliente',
                //     content: 'Para baixarmos o modelo de importação para mandar para alguma franquia, basta no menu clicar em <b>Importação</b>!',
                //     params: { cargos: [DONO],
                //         placement: 'left',
                //         menu: true,
                //         route: '/clientes/importacao',
                //         subMenu: true,
                //         subMenuTarget:"#group-cliente"
                //     }
                // },
                {
                    parent: '',
                    target: '',
                    content: '',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: false,
                        // route: '/gerenciamento-leads'
                    }
                },

            ],
        }),

        created() {
            this.steps = TourHelper.createSteps(this.steps);
            this.hideLoading();
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;
            this.cargoLider = LIDER;
            this.cargoParceiro = PARCEIRO;
            // if(self.$route.params)

            let self = this;
            api.get('processo/esteira').then(function (response) {
                let dataResponse = response.data.result.data;
                self.prospeccao = dataResponse.prospeccao;
                self.chamadaTelefonica = dataResponse.chamadaTelefonica;
                self.primeiraVisita = dataResponse.primeiraVisita;
                self.efetivado = dataResponse.efetivado;
                self.negativado = dataResponse.negativado;
                self.segundaVisita = dataResponse.segundaVisita;
                self.emEspera = dataResponse.emEspera;
                self.perdido = dataResponse.perdido;
                self.negociacao = dataResponse.negociacao;
                self.totalLeads = dataResponse.totalLeads;
                // self.hideLoading();
                if(TourStore.show() && window.innerWidth > 780){
                    swal({
                        text: 'Olá, nesta sequência vamos conhecer um pouco do Darwin, nosso CRM! Com ele podemos gerenciar e organizar os processos para melhorar o nosso relacionamento com os clientes. Não podemos esquecer nunca que o foco é garantir a agilidade e satisfação deles!',
                        showCancelButton: false,
                        confirmButtonText: 'Começar',
                        confirmButtonClass: 'btn btn-default waves-effect waves-light btn-swa-custom',
                        showCloseButton: true,
                        focusConfirm: false,
                        customClass: 'swa-tour',
                    }).then((result) => {
                        // console.log(result);
                        if (result.value) {
                            self.showTutorial = true;
                        }
                    });

                    $(".swal2-container").css('background-color', 'rgba(0, 0, 0, 0.8)');

                }
            });
        },

        methods: {
            abrirGrafico() {
                this.showGrafico = ! this.showGrafico;
            },
            checaCargoUsuario(arrayPode) {
                if (this.usuarioLogadoCargo === MASTER) {
                    return true;
                }
                return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
            },
            showLoading () {
                this.$parent.$emit('showLoading', true);
            },
            hideLoading () {
                this.$parent.$emit('showLoading', false);
            },
            verificaArrayMes(array) {
                let meses = {
                    jan: 0,
                    fev: 0,
                    mar: 0,
                    abr: 0,
                    mai: 0,
                    jun: 0,
                    jul: 0,
                    ago: 0,
                    set: 0,
                    out: 0,
                    nov: 0,
                    dez: 0
                };

                if (array.length > 0) {
                    array.forEach((obj) => {
                        let date = new Date(obj.data_alteracao);

                        switch (date.getMonth()) {
                            case 0:
                                meses.jan += 1;
                                break;
                            case 1:
                                meses.fev += 1;
                                break;
                            case 2:
                                meses.mar += 1;
                                break;
                            case 3:
                                meses.abr += 1;
                                break;
                            case 4:
                                meses.mai += 1;
                                break;
                            case 5:
                                meses.jun += 1;
                                break;
                            case 6:
                                meses.jul += 1;
                                break;
                            case 7:
                                meses.ago += 1;
                                break;
                            case 8:
                                meses.set += 1;
                                break;
                            case 9:
                                meses.out += 1;
                                break;
                            case 10:
                                meses.nov += 1;
                                break;
                            case 11:
                                meses.dez += 1;
                                break;
                        }
                    });
                }

                return meses;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue